import React from "react";

import { Control, Controller, RegisterOptions } from "react-hook-form";

import styled from "@emotion/styled";

import ErrorMessage from "../../../../shared/forms/ReactHookInput/ErroMessage";

interface iCheckboxProps {
    name: string;
    control: Control<any>;
    rules?: RegisterOptions;
    placeholder?: string;
    children?: React.ReactNode;
}

export const CheckboxContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 1em;
    padding-top: 1em;
    padding-bottom: 1em;
`;

const Row = styled.div`
    display: flex;
    gap: 1em;
    align-items: start;
    justify-content: start;
`;

const StyledCheckbox = styled.input`
    min-width: 1.5em;
    min-height: 1.5em;
    cursor: pointer;
    accent-color: ${({ theme }) => theme.colors.blue.toString()};
`;

const Error = styled.span`
    font-size: small;
    color: ${({ theme }) => theme.colors.red.toString()};
`;

const Checkbox = ({
    name,
    control,
    rules = { required: false },
    children,
    placeholder,
}: iCheckboxProps) => {
    return (
        <Controller
            control={control}
            name={name}
            defaultValue={false}
            rules={rules}
            render={({ field, fieldState }) => (
                <>
                    <Row>
                        <StyledCheckbox
                            {...field}
                            id={name}
                            type="checkbox"
                            checked={field.value}
                            onChange={(e) => {
                                field.onChange(e);
                            }}
                        />
                        {children && <label htmlFor={name}>{children}</label>}
                    </Row>
                    {fieldState.error && (
                        <ErrorMessage
                            error={fieldState.error}
                            name={placeholder ?? name}
                            rules={rules}
                        />
                    )}
                    {fieldState.error && (
                        <Error>{fieldState.error.message}</Error>
                    )}
                </>
            )}
        />
    );
};

export default Checkbox;
